import React from 'react';
import { useImpressionRef } from '@noths/polaris-client-react-hooks';
import { type IconName, Icon } from '@noths/polaris-design-system-core-components';

import * as styles from './ProductFeatures.styles';

export enum ProductFeature {
  FreeGiftWrappingAvailable,
  GiftWrappingAvailable,
  PhotoPersonalisation,
  Personalisable,
  MadeInBritain,
  MadeToOrder,
}

export interface ProductFeatureItem {
  icon: IconName;
  /** Renders the label in the link colour, e.g. "Made to Order" */
  isLink?: boolean;
  label: string;
}

export interface ProductFeaturesProps {
  features: ProductFeatureItem[];
  onVisible?: (productFeaturesLabels: string) => void;
}

export const ProductFeatures = ({ features, onVisible }: ProductFeaturesProps) => {
  const productFeaturesLabels = features.map(({ label }) => label).join(', ');
  const productFeaturesRef = useImpressionRef<HTMLUListElement>(() =>
    onVisible?.(productFeaturesLabels),
  );

  return (
    <ul css={styles.list} ref={productFeaturesRef}>
      {features.map(({ icon, isLink, label }) => (
        <li css={styles.listItem} key={label}>
          <span css={styles.iconBadge}>
            <Icon name={icon} size="sm" />
          </span>
          <span css={isLink ? styles.linkText : styles.text}>{label}</span>
        </li>
      ))}
    </ul>
  );
};
